import React, { useState } from 'react';
//bottomSheet
import { BottomSheet } from 'react-spring-bottom-sheet';
import 'src/asset/scss/plugin/bottomsheet/style.scss';
import 'src/asset/scss/plugin/bottomsheet/bottomsheet.scss';
//fontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//styles 
import styles from 'src/asset/scss/plugin/daterange/date.range.module.scss';
//react-date-range
import { ko } from 'date-fns/esm/locale';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import 'src/asset/scss/plugin/daterange/date.range.scss';

export default function DateRangePicker(props) {
    const { isOpen, startDate, setStartDate, endDate, setEndDate, minDate, maxDate } = props;//props

    /* =============== 최초날짜셋팅 =============== */
    const [ state,setState ] = useState(
        [{
          startDate: startDate,
          endDate: endDate,
          key: 'selection'
        }]
    );
    /* =============== 최초날짜셋팅 =============== */
    /* =============== 날짜선택완료 =============== */
    const onChooseHandler = () => {
        setStartDate(state[0].startDate);
        setEndDate(state[0].endDate);
        props.onDismiss(false);
    }
    /* =============== 날짜선택완료 =============== */
    
    return (
        <BottomSheet open={isOpen} onDismiss={(e) => props.onDismiss(false)}
                    className={'bottomsheetContainer'}
            header={
                <>
                <button className={'bottomsheetDissmissButton'} onClick={(e) => props.onDismiss(false)}><FontAwesomeIcon icon="fa-light fa-xmark" /></button>
                <div style={{marginBottom:'3.75rem'}} className={'bottomsheetHeaderContainer'}>
                    <h1>기간설정</h1>
                </div>
                </>
            }
            footer={
				<div className={styles.bottomsheetDateRangeBtnArea}>
                    <button onClick={(e) => onChooseHandler()}>확인</button>
                </div>
            }
            snapPoints={({ maxHeight }) => maxHeight}
            skipInitialTransition={false} scrollLocking={false} expandOnContentDrag={true}>
            <DateRange
                locale={ko}
                editableDateInputs={true}
                onChange={item => setState([item.selection])}
                moveRangeOnFirstSelection={false}
                // minDate={minDate}
                maxDate={maxDate}
                ranges={state}
                rangeColors={[`#191A1A`]} />
        </BottomSheet>
    );
}